import Config from "../Config";
import { useRef, useState } from "react";

import BarBottom from "./BarBottom";

import MyRoute from "../helpers/MyRoute";
import './../Employess.css';
import Wall from "../modules/news/Wall";
import WallE from "../modules/news/ViewE";
import MsgE from "../modules/msgE/View";
import Kids from "../modules/kidsE/View";
import Free from "../modules/myJobs/View";
import HomeView from "../modules/homeE/View";

import MenuTop from "./EmployeeMenuTop";
import MenuLeft from "./EmployeeMenuLeft";
import MenuBottom from "./EmployessMenuBottom";



import notice_mp3 from '../notice.mp3'
import notice_ogg from '../notice.ogg'

import gomini from "../chat_mini.png";
import gomax from "../chat_max.png";
import goclose from "../chat_close.png";
import gosend from "../gosend.png";
import empty_user from "../empty_user.png";

import MediaBrowser from "../helpers/MediaBrowser";
import MediaLink from "../helpers/MediaLink";
import InputUploaderAttach from "../helpers/InputUploaderAttach";
import MenView from "../modules/men/View";


function EmployeeMainView(props)
{
    var startModule = MyRoute( window.location.href, "module" );
    var startView = MyRoute( window.location.href, "view" );
    var startId = MyRoute( window.location.href, "id" );

    var cssS = localStorage.getItem("style");
    if(cssS == undefined || cssS == null) cssS = 0;
    const [cssStyle, setCssStyle] = useState(cssS);

    const [globalVariable, setGlobalVariable]  = useState({           
    });

    const [menuVisible, setMenuVisible] = useState(1);
    const [mobile, setMobile] = useState(0);
    const [progressProc, setProressProc] = useState(-1);
    const [alertx, setAlertX] = useState(null);
    const [alertx_code, setAlertXCode] = useState('');
    const [alertx_crypt, setAlertXCrypt] = useState('');
    const [alertx_msg, setAlertXMsg] = useState('');

    const audioRefer = useRef();

    const [dialogChat, setDialogChat] = useState([]);

    const dialogChatWindow = [
        useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
        useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
        useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
    ];

    if(startModule == null || startModule == undefined) startModule = "newse";
    if(startView == null || startView == undefined) startView = "wall";
    if(startId == null || startId == undefined) startId = "-1";

    const [loc, setLoc] = useState({
        menuSelected: startModule,
        viewSelected: startView,
        startId: startId
    });



    const codeChange = (e) => {
        var x = e.target.value;
        setAlertXCode(x);
    }

    const closeDialog = (e) => {

        if(alertx.callback != null && alertx.callback != undefined)
        {
            var a = e.target.getAttribute('atr-type');
            alertx.callback(a);
        }

        setAlertXMsg('');
        setAlertX(null);
    }

    const changeMenuStatus = (visible) => {
        setMenuVisible(visible);
    }
    
    function isMobile() {
        const userAgent = navigator.userAgent;
        return /Android|iPhone|iPad|Windows Phone/i.test(userAgent);
    }

    const playNotice = (title)  => {

        if(title.length > 0 )
        {
                var tmpTitle = document.title;

                document.title = title;
    
                setTimeout( ()=>{
                    document.title = tmpTitle
                }, 500 );
    
                setTimeout( ()=>{
                    document.title = title
                }, 1000 );
    
                setTimeout( ()=>{
                    document.title = tmpTitle
                }, 1500 );
        }

        audioRefer.current.play();
         

    }
      
    const sendChatMessage = (e) => {

        var inx    = e.target.getAttribute("atr-inx");
        var typ = "none";
        var typId = -1;
        var text_input  = "";

        for(var k=0; k<dialogChat.length; k++)
            {                          
                if(k == inx)  
                {
                        typ = dialogChat[k].typ;
                        typId = dialogChat[k].typId;
                        text_input = dialogChat[k].text_input;
                        break;
                }         
            }

        if(typ == "none")     return;
        if(text_input.length < 1) return;

        setProressProc(-2);



        var row = {
           typ: typ,
           typId: typId,
           tresc: text_input, 
        }

        
        fetch( Config.master + '/rest_v1_msg,send_chat_msg', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })         
        .then(res => res.json() )
        .then(res => { 

                    setProressProc(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setProressProc(-1);  
                        if(res.status == 'OK') {
                              //

                              for(var k=0; k<dialogChat.length; k++)
                                {                          
                                    if(k == inx)  
                                    {
                                        dialogChat[k].text_input = "";

                                        setDialogChat( JSON.parse(JSON.stringify(dialogChat)) );

                                        refreshChat(false);
                                    }         
                                }
                        } 

                    }
        } )
        .catch(err => {          
                    showDialog( "Error", "I: " + err , "ok" , null);
                    setProressProc(-1);
        });

    }

    const openChat = (title, typ, typId)  => {                  
        dialogChat.push({
            status: 1, // 1 - okno otwarte, 2 - zminimalizowane
            title: title,
            typ: typ,
            typId: typId,
            text_input : "",
            text_dialog: [],
            lastId: -1,                                
        });          
        setDialogChat( [...dialogChat] );       
        refreshChat(false);     
    }

    const chatChange = (e) => {

        var option = e.target.getAttribute("atr-optionx");  //0 - usun 
        var inx    = e.target.getAttribute("atr-inx");

      //  var arr = new Array();  

        for(var k=0; k<dialogChat.length; k++)
            {
              //  if(option == "0" && k == inx) continue; //usun nie dodawaj..

                if(k == inx)   dialogChat[k].status = option;

              //  arr.push( dialogChat[k] );
            }
        setDialogChat( [...dialogChat] );
    }

    const onChangeChatValEnter = (e) => {

        if(e.key == "Enter" )
        {
                sendChatMessage(e);
                return false;
        }
    }

    const onChangeChatVal = (e) => {

           var inx    = e.target.getAttribute("atr-inx");
           var val    = e.target.value;


           //var arr = new Array();  

           for(var k=0; k<dialogChat.length; k++)
               {                        
                   if(k == inx)  
                   {
                     dialogChat[k].text_input = val;   
                   }
                 //  arr.push( dialogChat[k] );
               }


           setDialogChat(  [...dialogChat]  );        
           goBottom(inx);
    }


    

    const completeUploadAttach = (fileName, crypt, param1, param2) => {


        console.log(fileName + " | " + crypt + " | " + param1 + " | " + param2);

        var inx    =    param1;   // e.target.getAttribute("atr-inx");
        var typ = "none";
        var typId = -1;
        var text_input  = "";

        for(var k=0; k<dialogChat.length; k++)
            {                          
                if(k == inx)  
                {
                        typ = dialogChat[k].typ;
                        typId = dialogChat[k].typId;
                        text_input = dialogChat[k].text_input;
                        break;
                }         
            }

        text_input = "Załącznik";

        if(typ == "none")     return;
        if(text_input.length < 1) return;

        setProressProc(-2);



        var row = {
           typ: typ,
           typId: typId,
           tresc: text_input, 
           crypt: crypt,
        }

        
        fetch( Config.master + '/rest_v1_msg,send_chat_msg', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })         
        .then(res => res.json() )
        .then(res => { 

                    setProressProc(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setProressProc(-1);  
                        if(res.status == 'OK') {
                              //

                              for(var k=0; k<dialogChat.length; k++)
                                {                          
                                    if(k == inx)  
                                    {
                                        dialogChat[k].text_input = "";

                                      //  setDialogChat( JSON.parse(JSON.stringify(dialogChat)) );
                                        setDialogChat( [...dialogChat]);

                                        refreshChat(false);
                                    }         
                                }
                        } 

                    }
        } )
        .catch(err => {          
                    showDialog( "Error", "I: " + err , "ok" , null);
                    setProressProc(-1);
        });



    }

    const goBottom = (inx) => {
    
        if(dialogChatWindow[inx] == undefined || dialogChatWindow[inx] == null )
        {
             console.log("goBottom, no object (0x9834), " , inx, dialogChatWindow[inx]);
             return;
        }

        var element = dialogChatWindow[inx].current;

        if(element == null || element == undefined) 
        {
            console.log("goBottom, no object, " , inx, dialogChatWindow[inx]);
            return;
        }


        //console.log("goBottom", element.scrollTop , element.scrollHeight);

        element.scrollTop = element.scrollHeight;
       
    }

 



    const sendSMS = () => {

        console.log('Send SMS');

        setProressProc(-2);
        setAlertXMsg('Wysyłam...');
        setAlertXCode('');
        setAlertXCrypt('');

        fetch( Config.url + '/rest_v1,auth_send_sms', {
            method: 'POST', 
            body: JSON.stringify({
                param: alertx.param
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    setProressProc(-1);

                    if(res._sys_ == undefined)
                    {
                        showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);     
                       setAlertXMsg(res.result);                       
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        setAlertXMsg('Wysłano kod nr '+ res.result +' (poczekaj ok. 1 min.)');
                    }else
                    {                            
                        setAlertXMsg(res.result);
                    }
                   
         } )
         .catch(err => {   
                    setProressProc(-1);       
                    showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


    const sendSMS_getcrypt = () => {

        console.log('Send SMS');
     

        if(alertx_code.length < 3)
            {
                return;
            }

        setProressProc(-2);
        setAlertXMsg('Sprawdzam...');
 

        fetch( Config.url + '/rest_v1,auth_check_sms', {
            method: 'POST', 
            body: JSON.stringify({
                sms: alertx_code
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    setProressProc(-1);

                    if(res._sys_ == undefined)
                    {
                        showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setAlertXMsg(res.result);  
                       setAlertXCode(''); 
                       setAlertXCrypt('');
                    
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        setAlertXMsg('Kod prawidłowy');
                        setAlertXCrypt(res.result);
                        setAlertXCode('');  

                        alertx.callback(res.result);                        
                        setAlertX(null);

                    }else
                    {                            
                        setAlertXMsg(res.result);
                        setAlertXCode(''); 
                       setAlertXCrypt('');
                    }
                   
         } )
         .catch(err => {   
                    setProressProc(-1);       
                    showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }

    var dialog = null;

    if(alertx != null && alertx.title.length > 0 && alertx.type == "ok" )
    {
        dialog = <div className="dlg_window shadowx">
                   <div className="dlg_title">{alertx.title}</div>
                   <div className="dlg_msg">{alertx.msg}</div>
                   <div className="dlg_btn">
                      <div className="btn" atr-type="ok" onClick={closeDialog}> {props.userData.dic.dlg_ok}</div>
                   </div>
        </div>;
    }

    if(alertx != null && alertx.title.length > 0 && alertx.type == "yesno" )
    {
        dialog = <div className="dlg_window shadowx">
                   <div className="dlg_title">{alertx.title}</div>
                   <div className="dlg_msg">{alertx.msg}</div>
                   <div className="dlg_btn">
                      <div className="btn" atr-type="yes" onClick={closeDialog}> {props.userData.dic.dlg_yes}</div>
                      &nbsp; &nbsp;
                      <div className="btn" atr-type="no" onClick={closeDialog}> {props.userData.dic.dlg_no}</div>
                   </div>
        </div>;
    }


    if(alertx != null && alertx.title.length > 0 && alertx.type == "auth" )
        {
            dialog = <div className="dlg_window dlg_window_auth shadowx">
                       <div className="dlg_title">{alertx.title}</div>
                       <div className="dlg_msg">{alertx.msg}</div>
                       <div className="dlg_msg">
                              <input type="text" value={alertx_code} onChange={codeChange} placeholder="*Kod SMS: " />  
                              &nbsp;
                              <sup className="link_color" onClick={sendSMS}>wyślij kod</sup>
                       </div>
                       <div className="dlg_msg">{alertx_msg}</div>                           
                       <div className="dlg_btn">
                          <div className="btn" atr-type="yes"  onClick={sendSMS_getcrypt} >Wykonaj</div>
                          &nbsp; &nbsp;
                          <div className="btn" atr-type="no" onClick={closeDialog}>Anuluj</div>
                       </div>
                       <div className="dlg_short_info">*Operacje możesz potwierdzić ostatnim otrzymanym kodem SMS<br/>jeśli data ważności nie uległa przedawnieniu. </div>
            </div>;
        }

    
    const deleteMsg = (e) => {


        var id = e.target.getAttribute('atr-id');;

        setProressProc(-2);



        var row = {
           id: id,               
        }

        
        fetch( Config.master + '/rest_v1_msg,delete_chat_msg', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })         
        .then(res => res.json() )
        .then(res => { 

                    setProressProc(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setProressProc(-1);  
                        if(res.status == 'OK') {
                             
                             e.target.parentNode.innerHTML = "";

                        } 

                    }
        } )
        .catch(err => {          
                    showDialog( "Error", "I: " + err , "ok" , null);
                    setProressProc(-1);
        });

    }

    const clickMenu = (item, item2, item3) => {
            
        sessionStorage.setItem("click-action-count", 0); //wyzeruj licznik zbyt duzej ilosci wywołań..
         

        //console.log("clickMenu " + item + " " + item2 + " " + item3);

        //return false;

        setLoc( { ...loc , ["menuSelected"]:item, ["viewSelected"]:item2,["startId"]:item3  } );         


        //const url = new URL(window.location);
        //url.searchParams.set("foo", "bar");

        var url = "";
        if(item != undefined && item.length > 0) url = url + "/module/"+item;
        if(item2 != undefined && item2.length > 0) url = url + "/view/"+item2;
   //     window.history.pushState({}, "", url);     
        window.history.pushState({page: url}, "", url);  

        if (isMobile()) {
            setMenuVisible(1);
        } 

        props.goRefresh();     
    }  

    const setStyle = (num) => { 

        localStorage.setItem("style", num);
        setCssStyle(num);
    } 

    const [preperListener, setPriperListener] = useState({
        status: 0,
        keyListeners: [],      
        refreshView: props.userData.refreshView 
    });
    //props.logout;

    const showDialog = (title, msg, type, callback, param ) => {

        

        setAlertX(
            {
                title: title,
                msg: msg,
                type:type,
                callback: callback,
                param: param,
            }
        );
    }  

    

    const setProgressAndCountClick = (proc) =>{

        setProressProc(proc);
        
        if(proc == -2)
        {
                var c = sessionStorage.getItem("click-action-count");

                if(c == undefined || c == null)
                {
                    c = 0;
                }

                c++;


                if(c > 1000 )
                {
                    props.logout();
                    //window.location.reload();
                    window.location.href = "https://app.elizak.edu.pl?to-much-redirect=true";
                }


                sessionStorage.setItem("click-action-count", c);
        }
    }

    const quickGo = (e) => {

            
        var module = e.target.getAttribute("module");
        var view = e.target.getAttribute("view");
        var id = e.target.getAttribute("id");
        clickMenu(module,view,id);


         if(module == "men")
            {
                changeMenuStatus(0);
            }

            if(module == "home" && view == "start")
            {
                changeMenuStatus(1);
            }
            
    }

    const writeFilter = (uq_name, val) => {

        var filterTab = {};        

        var tmp = sessionStorage.getItem("filter_tab");
        if(tmp != null && tmp != undefined)
            {               
                filterTab = JSON.parse(tmp);                    
            }                                
 
         var newTab = {[uq_name]:val}   ;
         var dt = {...filterTab,...newTab};
            
         sessionStorage.setItem('filter_tab', JSON.stringify(dt) );

       // console.log("writeFilter", uq_name, val, dt);
    }
    
    const readFilter = (uq_name, def) => {

        var filterTab = [];

        var tmp = sessionStorage.getItem("filter_tab");
        if(tmp != null && tmp != undefined)
            {
                filterTab = JSON.parse(tmp);
            }

        if(filterTab[uq_name] != null && filterTab[uq_name] != undefined )    
            {
                var tx = filterTab[uq_name];
                if(tx != undefined && tx != null) return tx;
            }

        return def;
    }

    const setGlobal = (vName, vValue) => {
                    
        if(vName == '_x_')
        {
           
            setGlobalVariable(  vValue );                
        }else
        {
            setGlobalVariable(  {  ...globalVariable, [vName]:vValue } );                       
        }
    }
      
    const getGlobal = (vName) => { 
        return globalVariable[vName];
    }

    function isMobile() {
        const userAgent = navigator.userAgent;
        return /Android|iPhone|iPad|Windows Phone/i.test(userAgent);
    }

    const removeKeyListener = (  uqName ) => {


        for(var k=0; k<preperListener.keyListeners.length; k++)
            {
                if(preperListener.keyListeners[k].name == uqName)
                {
                    preperListener.keyListeners[k].func = null;        
                    
                    console.log("mainView, removeKeyListener", uqName );
                    return;
                }
            }
    }



    const addKeyListener = ( handle,  uqName, func ) => {

        
        for(var k=0; k<preperListener.keyListeners.length; k++)
        {
            if(preperListener.keyListeners[k].name == uqName)
            {
                preperListener.keyListeners[k].func = func;        
                
               // console.log("mainView, registerKeyListner - override ", uqName );
                return;
            }
        }

       
            var kl =  {
                handle: handle,
                name: uqName,
                func: func
            }

            preperListener.keyListeners.push(kl);
            console.log("mainView, registerKeyListner ", uqName );
       
  
    }

    const refreshChat =  (fromTimer) => {



        for(var actIndex=0 ; actIndex < dialogChat.length; actIndex++)
        { 
            if(    dialogChat[actIndex].status == 1 || dialogChat[actIndex].status == 2  )
                {
                       
                                var od_id = -1;

                                if(dialogChat[actIndex].text_dialog.length > 0)
                                {
                                    od_id = dialogChat[actIndex].text_dialog[0].id;
                                }
                       
                                var row = {
                                    typ: dialogChat[actIndex].typ,
                                    typId:  dialogChat[actIndex].typId,        
                                    od_id: od_id,                 
                                }
    
                                
                                fetch( Config.master + '/rest_v1_msg,recv_chat_msg', {  //bo pliki sa wyslane do mastera..
                                    method: 'POST', 
                                    body: JSON.stringify(row), 
                                    headers: {
                                        'Content-Type': 'application/json',                    
                                        'X-Api-Key': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })         
                                .then(res => res.json() )
                                .then(res => { 
    
                                         
                                            if(res._sys_ == undefined)
                                            {
                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                            }else
                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                            {
                                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                            }else    
                                            {
                                           
                                                if(res.status == 'OK' ) {
                                                     

                                                    var xTyp   = res.result.typ;
                                                    var xTypId = res.result.typId;
                                                    var xRows = res.result.rows;

                                           
                                                    var addedNew = false;

                                                    for(var w=0; w<dialogChat.length; w++)
                                                    {
                                                        if(  ( dialogChat[w].status == 1 || dialogChat[w].status == 2 )  &&  dialogChat[w].typ == xTyp && dialogChat[w].typId == xTypId &&  xRows.length > 0 )  
                                                        {
                                                               

                                                            var tmp = [...dialogChat[w].text_dialog];


                                                            dialogChat[w].text_dialog = new Array();

                                                            for(var mx=0; mx<xRows.length; mx++)
                                                            {
                                                                dialogChat[w].text_dialog.push(xRows[mx]); 

                                                                if(xRows[mx].wlasciciel == 0) addedNew = true;

                                                            }

                                                            for(var xt =0; xt<tmp.length; xt++)
                                                            {
                                                                dialogChat[w].text_dialog.push( tmp[xt] );   
                                                            }

                                                            setDialogChat( [...dialogChat] );

                                                            setTimeout( () => {
                                                                console.log("gtobottom", w)
                                                                goBottom(w)
                                                            } , 200 );                                                                                                                             

                                                         
                                                            break;
                                                        }
                                                    }

                                                    if(addedNew && fromTimer)
                                                    {
                                                        playNotice("Nowa wiadomość");
                                                    }

                                                } 
    
                                            }
                                } )
                                .catch(err => {          
                                            showDialog( "Error", "I: " + err , "ok" , null);
                                          
                                });
    
    
    
                }
       

        }

    }

    const refreshHandle = ()  => {

        refreshChat(true);
    }
    
    

    var mainView = {   
           
        menuSelected: loc.menuSelected,
        viewSelected: loc.viewSelected,
        idSelected: loc.startId,
        menuVisible: menuVisible,
        changeMenuStatus: changeMenuStatus,
        clickMenu: clickMenu,
        quickGo: quickGo, 
        changeProfile: props.changeProfile,
        changeLang: props.changeLang,
        logout: props.logout,
        showDialog: showDialog,
        setProgress: setProgressAndCountClick,
        readFilter: readFilter,
        writeFilter:writeFilter,
        addKeyListener: addKeyListener,
        removeKeyListener: removeKeyListener,
        isMobile: isMobile,
        openChat: openChat,
        refreshHandle: refreshHandle,  //przychodzi sygnało od Menu Top,
        setGlobal: setGlobal,
        getGlobal: getGlobal,
        setStyle: setStyle,
    };

    const logout = () => {
        props.logout();
    }

    var content = "Wybierz opcje z menu";  

    switch(loc.menuSelected)
    {   

        case 'homeE': 
            {
                content = <HomeView userData={props.userData} mainView={mainView}   />
            }break;


        case 'news': 
        {
            content = <div className="econtent "><Wall userData={props.userData}  mainView={mainView}  /></div>
        } break;

        case 'newse': 
        {
            content = <div className="econtent "><WallE userData={props.userData}  mainView={mainView}  /></div>
        } break;

        case 'msg': 
        {
            content = <MsgE userData={props.userData}  mainView={mainView}  />
        } break;

        case 'kidsE': 
        {
            content = <Kids userData={props.userData}  mainView={mainView}  />
        } break;

         case 'men': 
            {
                content = <MenView userData={props.userData}  mainView={mainView}  />                
            }break;

     

        case 'myJobs': 
        {
            content = <div className="econtent "> <Free userData={props.userData}  mainView={mainView}  /> </div>
        } break;

        default: {
            content = <div className="econtent "><Wall userData={props.userData}  mainView={mainView}  /></div>
        }
    }

    var cssX = "";
    
    if(menuVisible == 0) cssX = "full_screen";

    if(cssStyle == 0)
    {
        cssX = cssX + " styleGreen "; //def..
    }

    if(cssStyle == 1)
    {
        cssX = cssX + " styleGreen ";
    }

    if(cssStyle == 2)
    {
        cssX = cssX + " styleWhite ";
    }

//



    return( 
    <div className={ "elizak employee " + cssX}>
        
        <MenuTop   userData={props.userData}  mainView={mainView}  />                                      
        <MenuLeft  userData={props.userData}  mainView={mainView}/>   
        <div>
            {content} 

            {dialog}
        </div>
        
        <MenuBottom userData={props.userData}  mainView={mainView}/>
        
        <audio  ref={audioRefer}>
                        <source src={notice_ogg} type="audio/ogg" />
                        <source src={notice_mp3} type="audio/mpeg" />                       
                  </audio>

                 
                    
                   
                  


                        {
                            dialogChat.map( (chat, ix) => {

                                    if(chat.status == "1")
                                    {

                                      
                                   

                                        return <div className="dialog_chat"><div className="dialog_chat_item shadowx">
                                                <div className="dialog_chat_title">

                                                       <div className="g_left">
                                                            {chat.title}
                                                       </div>

                                                       <div className="g_right">                                                         
                                                            <img   atr-inx={ix} atr-optionx="2" onClick={chatChange}   src={gomini} class="link_color hidden_mobile" title="Zminimalizuj"  />                                                     
                                                            <img   atr-inx={ix} atr-optionx="0" onClick={chatChange}  src={goclose} class="link_color" title="Zamknij" />
                                                       </div>
                                                    
                                                                                                         
                                                </div>
                                                <div className="dialog_chat_content">
                                                    <div className="chat_scroll" ref={ dialogChatWindow[ix]}>

                                                        
                                                        {
                                                           
                                                           [...chat.text_dialog].reverse().map(  (row, irow) => {

                                                                    if(row.wlasciciel == 1)
                                                                    {
                                                                        var aw = empty_user;
                                                                                            
                                                                        if( row.nadawca.awatar != null &&  row.nadawca.awatar.length > 10)
                                                                        {
                                                                                aw = "data:image/png;base64," + row.nadawca.awatar;
                                                                        }


                                                                        return <div className="dlg_chat_item dlg_right">                                                                                
                                                                               <div className="dlg_chat_nd">{row.nadawca.nazwa} <img src={aw} /> </div>
                                                                               <div className="dlg_chat_cc">{row.czas}</div>
                                                                               <br/>
                                                                               <div className="dlg_chat_txt">{row.tresc}</div>
                                                                               <br/>
                                                                               <sup className="link_color" atr-id={row.id} onClick={deleteMsg} >usuń</sup> 
                                                                               <br/>
                                                                                <div className="dlg_attach">
                                                                                {
                                                                                    row.zalaczniki.map( ( zal, inxZal) => {

                                                                                        if( ( zal.typ_pliku=='png' ||  zal.typ_pliku=='jpg' ||  zal.typ_pliku=='jpeg' ||  zal.typ_pliku=='mp4' ) && zal.b64.length > 1 || zal.vid.length > 1 )
                                                                                            {
                                                                                                return <MediaBrowser userData={props.userData} mainView={mainView}  review={zal.b64} typ="p_wiadomosci" typId={row.id} />
                                                                                            }else
                                                                                            {
                                                                                                return <div>
                                                                                                    
                                                                                                       <MediaLink userData={props.userData} mainView={mainView} title={zal.nazwa} link={ Config.url + "/api,image,secure," + zal.api_unique} />  
                                                                                                       <br/>&nbsp; <br/>
                                                                                                </div>
                                                                                            
                                                                                            }
                                                                                    } )
                                                                                }
                                                                                </div>

                                                                          </div>
                                                                    }

                                                                    if(row.wlasciciel == 0)
                                                                    {
                                                                                var aw = empty_user;
                                                                                            
                                                                                if( row.nadawca.awatar != null &&  row.nadawca.awatar.length > 10)
                                                                                {
                                                                                        aw = "data:image/png;base64," + row.nadawca.awatar;
                                                                                }

                                                                            return <div className="dlg_chat_item dlg_left">                                                                                
                                                                                   <div className="dlg_chat_nd"> <img src={aw} /> {row.nadawca.nazwa}</div>
                                                                                   <div className="dlg_chat_cc">{row.czas}</div>
                                                                                   <br/>
                                                                                   <div className="dlg_chat_txt">{row.tresc}</div>
                                                                                   <br/>
                                                                                   <div className="dlg_attach">
                                                                                {
                                                                                    row.zalaczniki.map( ( zal, inxZal) => {

                                                                                        if( ( zal.typ_pliku=='png' ||  zal.typ_pliku=='jpg' ||  zal.typ_pliku=='jpeg' ||  zal.typ_pliku=='mp4' ) && zal.b64.length > 1 || zal.vid.length > 1 )
                                                                                            {
                                                                                                return <MediaBrowser userData={props.userData} mainView={mainView}  review={zal.b64} typ="p_wiadomosci" typId={row.id} />
                                                                                            }else
                                                                                            {
                                                                                                return <div>                                                                                                
                                                                                                    <MediaLink userData={props.userData} mainView={mainView} title={zal.nazwa} link={ Config.url + "/api,image,secure," + zal.api_unique} />  
                                                                                                    <br/>&nbsp; <br/>
                                                                                                </div>
                                                                                            }
                                                                                    } )
                                                                                }
                                                                                </div>
                                                                              </div>
                                                                    }

                                                            }  ) 
                                                        }

                                                    </div>
                                                    <div className="chat_input">
                                                        <textarea value={chat.text_input} className="chat_area" onChange={onChangeChatVal} onKeyDown={onChangeChatValEnter} atr-inx={ix} placeholder="Napisz coś...">
                                                        </textarea>
                                                        <div className="chat_btn">
                                                            <img      src={gosend} class="link_color" title="Pokaż" atr-inx={ix}   onClick={sendChatMessage} />                                                            
                                                      

                                                            <InputUploaderAttach   userData={props.userData}  param1={ix} param2={""}  completeUpload={completeUploadAttach} title={ "-dodaj załącznik-" } max_files="10" ext="*/*" />                    
                                         
                                                        </div>
                                                    </div>
                                                </div>                                    
                                        </div>
                                        </div>
                                    }

                                    if(chat.status == "2")
                                        {
                                            return <div className="dialog_chat">
                                                    <div className="dialog_chat_item shadowx">
                                                        <div className="dialog_chat_title">
                                                                <img   atr-inx={ix} atr-optionx="0" onClick={chatChange}  src={goclose} class="link_color" title="Zamknij" />
                                                                <img   atr-inx={ix} atr-optionx="1" onClick={chatChange}   src={gomax} class="link_color" title="Pokaż"  />
                                                                {chat.title}
                                                        </div>                                                                                     
                                                    </div>
                                                </div>
                                        }
                                   


                            } )                    
                        }
        <BarBottom progress={progressProc} />                
    </div>
    )
}


export default EmployeeMainView;